import { type VisibilityAccessRoleRef } from '@blaze-shared/elements-domain';
import { mergeDefinedIntoArray } from '@blaze-shared/shared-util';

import {
  extractActionsPageRefs,
  extractElementActionWorkflowsRefs,
} from '../../canvas-elements/element-model/props-extractor';
import { PropsExtractor } from '../__base/props-extractor';

export class ChatPropsExtractor extends PropsExtractor<'chat'> {
  override getPageReferences: () => string[] = () => {
    if (!this.props?.content) {
      return [];
    }
    return extractActionsPageRefs(this.props.content.actions);
  };

  override getVisibilityAccessRolesRefs(): VisibilityAccessRoleRef[] {
    return mergeDefinedIntoArray(
      ...super.getVisibilityAccessRolesRefs(),
      ...extractElementActionWorkflowsRefs(this.props?.content?.actions),
    );
  }
}
